//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/carre-vide.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/carre-tick.svg';
export default {
  name: 'MdmCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentValue: this.value
    };
  },

  computed: {
    name() {
      return this.value ? 'carre-tick' : 'carre-vide';
    }

  }
};